import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import ContainerComponent from "../../components/conatiner";
import HeaderComponent from "../../components/header";
import InputComponent from "../../components/input";
import { MangersDashboardSearchService, MangersDashboardService } from "../../services/managers/dashboard";
import LoadingComponent from "../../components/loading";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { ToastErro } from "../../components/toast";
import moment from "moment";
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    BarElement,
} from 'chart.js';
import { Pie, Line, Bar } from 'react-chartjs-2';

const ManagersDashboardPage = () => {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        ArcElement,
        Tooltip,
        Legend,
        BarElement,
    );

    const [loading, setLoading] = useState<boolean>(true);
    const [loadingSearch, setLoadingSearch] = useState<boolean>(true);

    const [costCenters, setCostCenters] = useState<any>([]);
    const [employees, setEmployees] = useState<any>([]);
    const [status, setStatus] = useState<any>([]);

    const [spendingTypes, setSpendingTypes] = useState<any>([]);
    const [spendingCostCenters, setSpendingCostCenters] = useState<any>([]);
    const [spendingUserTypes, setSpendingUserTypes] = useState<any>([]);

    const [dataChart, setDataChart] = useState<any>({
        spendingUserTypes,
        datasets: []
    });
    const [dataChartBar, setDataChartBar] = useState<any>({
        spendingUserTypes,
        datasets: []
    });


    // variáveis de pesquisa
    const [searchEmployee, setSearchEmployee] = useState<any>([]);
    const [serachCostCenter, setSearchCostCenter] = useState<any>([]);
    const [searchStatus, setSearchStatus] = useState<any>([]);
    const [startDate, setStartDate] = useState<string>(moment().subtract(1, 'months').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState<string>(moment().format('YYYY-MM-DD'));
    // variáveis de pesquisa

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };



    // função para pesquisar os dados de pesquisa
    const getSearch = async () => {
        setLoadingSearch(true);
        await MangersDashboardSearchService().then(resp => {
            console.log(resp.data.employees)
            setCostCenters(resp.data.costCenters);
            setEmployees(resp.data.employees);
            setStatus(resp.data.status);
        });
        setLoadingSearch(false);
    }
    // função para pesquisar os dados de pesquisa

    // função para pesquisar dados da dashboard
    const getData = async () => {

        // formatar pesquisa de funcionários
        let formatEmployees: number[] = [];

        if (searchEmployee.length > 0) {
            searchEmployee.map((s: any) => {
                formatEmployees.push(s.id);
            });
        } else {
            employees.map((s: any) => {
                formatEmployees.push(s.id);
            });
        }
        // formatar pesquisa de funcionários

        // formatar pesquisa de funcionários
        let formatCostCenter: number[] = [];

        if (serachCostCenter.length > 0) {
            serachCostCenter.map((s: any) => {
                formatCostCenter.push(s.id);
            });
        } else {
            costCenters.map((s: any) => {
                formatCostCenter.push(s.id);
            });
        }
        // formatar pesquisa de funcionários

        // formatar pesquisa de funcionários
        let formatStatus: number[] = [];

        if (searchStatus.length > 0) {
            searchStatus.map((s: any) => {
                formatStatus.push(s.id);
            });
        } else {
            status.map((s: any) => {
                formatStatus.push(s.id);
            });
        }
        // formatar pesquisa de funcionários

        if (startDate.length < 1 || endDate.length < 1) {
            ToastErro('Informe a data inicial e a data final!');
            return;
        }

        setLoading(true);

        await MangersDashboardService(JSON.stringify(formatEmployees), JSON.stringify(formatCostCenter), JSON.stringify(formatStatus), startDate, endDate).then(resp => {

            setSpendingTypes(resp.data.spendingTypes);
            setSpendingCostCenters(resp.data.spendingCostCenters);

            const labels = resp.data.employees;

            setDataChart({
                labels,
                datasets: resp.data.spendingUserTypes.map((u: any) => (
                    {
                        label: u.type.description,
                        data: u.values.map((v: any) => v.value),
                        borderColor: u.type.color,
                        backgroundColor: u.type.color,
                    }
                ))
            });

            const labelsMonths = resp.data.spendingStates.map((s: any) => s.description);

            setDataChartBar({
                labels: labelsMonths,
                datasets: [
                    {
                        label: 'Estados',
                        data: resp.data.spendingStates.map((s: any) => s.value),
                        backgroundColor: 'rgba(53, 162, 235, 0.8)',
                    }
                ],
            })

        });

        setLoading(false);

    }
    // função para pesquisar dados da dashboard

    useEffect(() => {
        getSearch();
    }, []);

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Dashboard"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        {
                            loadingSearch

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <div className="col-md-4 mb-4">
                                            <Autocomplete
                                                size="small"
                                                multiple
                                                className="w-100"
                                                options={employees}
                                                disableCloseOnSelect
                                                getOptionLabel={(employee: any) => `${employee.id} - ${employee.name}`}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                       {option.id} - {option.name}
                                                    </li>
                                                )}
                                                style={{ width: 500 }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Funcionários" placeholder="Pesquisar" />
                                                )}
                                                value={searchEmployee}
                                                onChange={(e: any, newValue: any) => {
                                                    setSearchEmployee(newValue);
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-4">
                                            <Autocomplete
                                                size="small"
                                                multiple
                                                className="w-100"
                                                options={costCenters}
                                                disableCloseOnSelect
                                                getOptionLabel={(costCenter: any) => costCenter.description}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.branch + ' - ' + option.description}
                                                    </li>
                                                )}
                                                style={{ width: 500 }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Centro de Custo" placeholder="Pesquisar" />
                                                )}
                                                value={serachCostCenter}
                                                onChange={(event: any, newValue: any) => {
                                                    setSearchCostCenter(newValue);
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-4">
                                            <Autocomplete
                                                size="small"
                                                multiple
                                                className="w-100"
                                                options={status}
                                                disableCloseOnSelect
                                                getOptionLabel={(status: any) => status.description}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.description}
                                                    </li>
                                                )}
                                                style={{ width: 500 }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Status" placeholder="Pesquisar" />
                                                )}
                                                value={searchStatus}
                                                onChange={(event: any, newValue: any) => {
                                                    setSearchStatus(newValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Data Inicial"
                                            col={4}
                                            type={'date'}
                                            shrink
                                            size={'small'}
                                            defaultValue={startDate}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => setStartDate(e.target.value)}
                                        />
                                        <InputComponent
                                            label="Data Inicial"
                                            col={4}
                                            type={'date'}
                                            shrink
                                            size={'small'}
                                            defaultValue={endDate}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => setEndDate(e.target.value)}
                                        />
                                        <div className="col-md-4">
                                            <button className="btn btn-primary" type="button" onClick={getData}>Pesquisar</button>
                                            <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                                        </div>
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>

                    {
                        loading

                            ?

                            <LoadingComponent />

                            :

                            <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <CardHeaderBackgroundComponent
                                            title="Gastos por Categoria"
                                        >
                                            {
                                                spendingTypes.length > 0

                                                    ?

                                                    <div style={{ height: 350 }}>
                                                        <Pie
                                                            data={{
                                                                labels: spendingTypes.map((s: any) => s.type),
                                                                datasets: [
                                                                    {
                                                                        label: 'Quantidade em Reais',
                                                                        data: spendingTypes.map((s: any) => s.value),
                                                                        backgroundColor: spendingTypes.map((s: any) => s.color),
                                                                    },
                                                                ],

                                                            }}
                                                            options={{
                                                                plugins: {
                                                                    legend: {
                                                                        position: 'top'
                                                                    },
                                                                    tooltip: {
                                                                        callbacks: {
                                                                            label: (context) => {
                                                                                const value: any = context.dataset.data[context.dataIndex];
                                                                                return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                                                            },
                                                                        },
                                                                    },
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    :

                                                    <p>Nenhum Gasto!</p>
                                            }
                                        </CardHeaderBackgroundComponent>
                                    </div>
                                    <div className="col-md-6">
                                        <CardHeaderBackgroundComponent
                                            title="Gastos por Centro de Custo"
                                        >
                                            {
                                                spendingCostCenters.length > 0

                                                    ?

                                                    <div style={{ height: 350 }}>
                                                        <Pie
                                                            data={{
                                                                labels: spendingCostCenters.map((s: any) => s.costCenter),
                                                                datasets: [
                                                                    {
                                                                        label: 'Quantidade em Reais',
                                                                        data: spendingCostCenters.map((s: any) => s.value),
                                                                        backgroundColor: spendingCostCenters.map(() => getRandomColor())
                                                                    },
                                                                ],

                                                            }}
                                                            options={{
                                                                plugins: {
                                                                    legend: {
                                                                        position: 'right' as const
                                                                    },
                                                                    tooltip: {
                                                                        callbacks: {
                                                                            label: (context) => {
                                                                                const value: any = context.dataset.data[context.dataIndex];
                                                                                return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                                                            },
                                                                        },
                                                                    },
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    :

                                                    <p>Nenhum Gasto!</p>
                                            }
                                        </CardHeaderBackgroundComponent>
                                    </div>
                                </div>
                                <CardHeaderBackgroundComponent
                                    title="Gastor Por Funcionário"
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Line
                                                options={{
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'top' as const,
                                                        },
                                                        title: {
                                                            display: false
                                                        },
                                                        tooltip: {
                                                            mode: 'index',
                                                            intersect: false,
                                                            callbacks: {
                                                                label: (context) => {
                                                                    const value: any = context.dataset.data[context.dataIndex];
                                                                    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                                                },
                                                            },


                                                        },
                                                    },
                                                }}
                                                data={dataChart}
                                                height={85}
                                            />
                                        </div>
                                    </div>
                                </CardHeaderBackgroundComponent>
                                <CardHeaderBackgroundComponent
                                    title="Gastos Por Estado"
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Bar
                                                options={{
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'top' as const,
                                                        },
                                                        title: {
                                                            display: true,
                                                            text: 'Chart.js Bar Chart',
                                                        },
                                                        tooltip: {
                                                            callbacks: {
                                                                label: (context) => {
                                                                    const value: any = context.dataset.data[context.dataIndex];
                                                                    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                                                },
                                                            },
                                                        },
                                                    },
                                                }}
                                                data={dataChartBar}
                                                height={90}
                                            />
                                        </div>
                                    </div>
                                </CardHeaderBackgroundComponent>
                            </>
                    }
                </>
            </ContainerComponent>
        </>
    )

}

export default ManagersDashboardPage;